export default "__VITE_ASSET__CD5rzKMR__"